import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./components/layout/Layout";
import InitiativeLayout from "./components/initiative/InitiativeLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Sports from "./pages/Sports";
import SportDetail from "./pages/SportDetail";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Branches from "./pages/Branches";
import BranchDetail from "./pages/BranchDetail";
import Achievements from "./pages/Achievements";
import SuccessStories from "./pages/SuccessStories";
import Team from "./pages/Team";
import Partners from "./pages/Partners";
import Activities from "./pages/Activities";
import Press from "./pages/Press";
import Testimonials from "./pages/Testimonials";
import Booking from "./pages/Booking";
import Donate from "./pages/Donate";
import Humanitarian from "./pages/Humanitarian";
import WarImpact from "./pages/WarImpact";
import ChampionsWithoutBorders from "./pages/ChampionsWithoutBorders";
import Initiative from "./pages/Initiative";
import InitiativeSponsor from "./pages/InitiativeSponsor";
import InitiativeCoaches from "./pages/InitiativeCoaches";
import NotFound from "./pages/NotFound";
import "@/i18n";

const queryClient = new QueryClient();

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const MainLayoutShell = () => (
  <Layout>
    <Outlet />
  </Layout>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Initiative landing pages — own header, own footer, focused style */}
          <Route element={<InitiativeLayout />}>
            <Route path="/initiative" element={<Initiative />} />
            <Route path="/initiative/sponsor" element={<InitiativeSponsor />} />
            <Route path="/initiative/coaches" element={<InitiativeCoaches />} />
          </Route>

          {/* Main site (server-side HTTP Basic Auth gates these routes via Nginx) */}
          <Route element={<MainLayoutShell />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/sports/:slug" element={<SportDetail />} />
            <Route path="/branches" element={<Branches />} />
            <Route path="/branches/:slug" element={<BranchDetail />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/team" element={<Team />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/press" element={<Press />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/humanitarian" element={<Humanitarian />} />
            <Route path="/martyrs-team" element={<Navigate to="/war-impact#team" replace />} />
            <Route path="/martyrs-players" element={<Navigate to="/war-impact#players" replace />} />
            <Route path="/war-impact" element={<WarImpact />} />
            <Route path="/champions-without-borders" element={<ChampionsWithoutBorders />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
